import { zodSortField } from "@/lib/utils";
import { z } from "zod";

export const WHOLESALER_MAX = 5;

export const getLemaSalesPersonsRequestSchema = z.object({
  sort: zodSortField(["lastname", "firstname", "lemaId"]).optional(),
  wholesalerNumber: z.string().trim().min(1).max(WHOLESALER_MAX).optional(),
  brandLetter: z.enum(["A", "V", "N", "S", "C"]).optional(),
});
